module.exports = __webpack_public_path__ + "Ubisoft-e730ad76.webp";